import { render, staticRenderFns } from "./PhotosCarousel.vue?vue&type=template&id=7da6007c&scoped=true&lang=pug&"
import script from "./PhotosCarousel.vue?vue&type=script&lang=js&"
export * from "./PhotosCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PhotosCarousel.vue?vue&type=style&index=0&id=7da6007c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da6007c",
  null
  
)

export default component.exports